import { gql } from '@apollo/client';

/**
 * Approval GraphQL Fragment - All 52 fields with nested types
 */
export const APPROVAL_FIELDS_FRAGMENT = gql`
  fragment ApprovalFields on Approval {
    # Identity (6 fields)
    id
    tenant
    approvalName
    approvalType
    slug
    externalId

    # Append-Only Architecture (5 fields)
    parentId
    originalId
    isActive
    changedBy
    changeReason

    # Formula Interaction (14 fields)
    approverId
    approverRole
    policyId
    workflowInstanceId
    taskId
    documentId
    entityId
    entityType
    nextApprovalId
    previousApprovalId
    approvalChainId
    validationResult
    aiRecommendation
    confidenceThreshold

    # Runtime State Tracking (10 fields)
    status
    startedAt
    reviewedAt
    decidedAt
    expiresAt
    decision
    decisionReason
    conditions
    escalatedTo
    escalationCount

    # Approval Metadata (8 fields)
    requiredApprovals
    currentApprovalCount
    approvalStrategy
    approvalLimits {
      role
      maxAmount
      currency
      requiresDualControl
      dualControlThreshold
    }
    delegatable
    delegatedTo
    evidenceUrls
    attachments

    # Decision Details (8 fields)
    approvers {
      actorId
      actorName
      role
      decision
      decidedAt
      comments
      signature
    }
    rejectionReason
    revisionRequestedReason
    revisionCount
    decisionHistory {
      eventId
      actorId
      decision
      timestamp
      reason
      metadata
    }
    comments {
      commentId
      actorId
      comment
      timestamp
      parentCommentId
    }
    tags
    priority

    # Policy Integration (4 fields)
    policyEvaluationResult
    policyViolations
    overrideAllowed
    overrideJustification

    # Lifecycle & Audit (4 fields)
    createdAt
    updatedAt
    createdBy
    metadata

    # Additional Fields (6 fields)
    requiresComment
    requiredApprovers
    retentionPolicy
    externalSystemRefs
    complianceFrameworks
    archived
  }
`;
